export default __webpack_public_path__ + "static/media/check-box.af1de1a5.svg";